<template>
  <div class="container-help" :style="cssVars()">
    <div class="custom-nav-block" :style="`padding-top:${topBarHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb" @click-right="toPage('/income/details')">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow02.webp" alt="" />
          <span class="tit-left">{{ $t('lang.BaseCommon.k072') }}</span>
        </template>
        <template #right>
          <span class="tit-right">{{ $t('lang.BaseCommon.k074') }}</span>
        </template>
      </van-nav-bar>
    </div>

    <div class="main">
      <div class="beans">
        <div class="beans-num">
          <img :src="getMatchImg('beans')" alt="" />
          {{ data.remainIncomeAmount }}
        </div>
        <span>{{ $t('lang.BaseCommon.k102') }}</span>
      </div>
      <div class="income">
        <div class="income-box total-income">
          <div class="num">
            <img :src="getMatchImg('beans')" alt="" />
            {{ data.sumIncomeAmount }}
          </div>
          <span>{{ $t('lang.BaseCommon.k081') }}</span>
          <span class="report-icon time" @click="toPage('/income/report')"></span>
        </div>
        <span class="line"></span>
        <div class="income-box week-income">
          <div class="num">
            <img :src="getMatchImg('beans')" alt="" />
            {{ data.thisWeekIncomeAmount }}
          </div>
          <span>{{ $t('lang.MyBeans.k016') }}</span>
        </div>
      </div>
      <div class="myincome-list">
        <div
          class="list-item"
          :class="{ todayIncome: key == $t('lang.MyBeans.k020'), lineBottom: key == $t('lang.MyBeans.k020') || key == $t('lang.BaseCommon.k079') }"
          v-for="(key, index) in list.keys()"
          :key="key"
        >
          <span>{{ key }}</span>
          <div class="myincome-beans">
            <i>{{ list.get(key) }}</i>
            <img v-if="index <= 7" :src="getMatchImg('beans')" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="withdrawal-box" :style="{ 'margin-bottom': `${bottomBarHeight}px` }">
      <div class="withdrawal" @click="toPage('/withdrawal')">
        {{ $t('lang.BaseCommon.k096') }}
      </div>
    </div>
  </div>
</template>

<script>
import { apiFetchMyBeans } from '@/api/imee.js'
import { pageCssVars } from './z-style-cfg.js'

export default {
  components: {},
  mixins: [pageCssVars],
  props: {},
  data() {
    return {
      data: {},
      list: new Map(),
    }
  },
  created() {
    this.fetchMyBeans()
  },
  mounted() {},
  methods: {
    toPage(path) {
      this.$router.push({
        path,
      })
    },
    fetchMyBeans() {
      apiFetchMyBeans().then((res) => {
        if (res) {
          this.data = res
          this.list.set(this.$t('lang.MyBeans.k020'), res.todayIncomeAmount)
          this.list.set(this.$t('lang.BaseCommon.k080'), res.videoCallTodayIncomeAmount)
          this.list.set(this.$t('lang.BaseCommon.k077'), res.videoPassTodayIncomeAmount)
          this.list.set(this.$t('lang.BaseCommon.k063'), res.messageTodayIncomeAmount)
          this.list.set(this.$t('lang.BaseCommon.k076'), res.giftTodayIncomeAmount)
          this.list.set(this.$t('lang.BaseCommon.k041'), res.taskTodayIncomeAmount)
          this.list.set(this.$t('lang.BaseCommon.k073'), res.bonusTodayIncomeAmount)
          this.list.set(this.$t('lang.BaseCommon.k079'), res.otherTodayIncomeAmount)
          this.list.set(this.$t('lang.MyBeans.k011'), this.transformSeconds4(res.onlineDuration)) // 返回的是多少秒 需要处理成xxm xxm xxs
          this.list.set(this.$t('lang.MyBeans.k023'), res.timesOfVideoCall)
          this.list.set(this.$t('lang.MyBeans.k022'), this.transformSeconds4(res.videoCallDuration)) // 返回的是多少秒 需要处理成xxm xxm xxs
          this.list.set(this.$t('lang.MyBeans.k002'), res.answeringRate + '%') // 返回的是数字  需要加百分号
          this.list.set(this.$t('lang.MyBeans.k008'), res.replyMessageUsers) //
        }
      })
    },
  },
  watch: {},
  computed: {},
}
</script>

<style lang="scss" scoped>
.container-help {
  position: relative;
  width: 100%;
  min-height: 100vh;
  padding-bottom: 80px;
  background: var(--mb-page-bg) no-repeat;
  background-size: 100% auto;

  .custom-nav-block {
    background: var(--mb-page-bg) no-repeat;
    background-size: 100% auto;

    ::v-deep .van-nav-bar__left {
      .tit-left {
        color: #fff;
      }
    }

    ::v-deep .van-nav-bar__right {
      .tit-right {
        color: #fff;
      }
    }
  }

  .main {
    margin-top: 20px;
    padding: 0 24px 100px;

    .beans {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      font-family: var(--number-font);

      .beans-num {
        display: flex;
        align-items: center;
        font-family: var(--number-font);
        font-size: var(--fs-24);
        font-weight: var(--fw-600);
        color: #ffffff;

        > img {
          width: 24px;
          margin: 0 2px;
        }
      }

      > span {
        display: block;
        margin-top: 10px;
        font-family: var(--string-font);
        font-size: var(--fs-14);
        font-weight: var(--fw-400);
        line-height: var(--lh-body-20);
        color: rgba($color: #ffffff, $alpha: 0.8);
      }
    }

    .income {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 327px;
      height: 85px;
      margin: 20px auto 0;
      background: #ffffff;
      border-radius: 10px;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.06);

      .income-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 40%;
        font-family: var(--string-font);
        font-size: var(--fs-12);
        font-weight: var(--fw-400);
        line-height: var(--lh-label-16);
        color: var(--mb-income-label-color);

        .num {
          display: flex;
          align-items: center;
          margin-bottom: 4px;
          font-family: var(--number-font);
          font-size: var(--fs-20);
          font-weight: var(--fw-500);
          color: var(--mb-income-num-color);

          > img {
            width: 18px;
            margin: 0 1px;
          }
        }

        &.total-income {
          position: relative;

          .report-icon {
            position: absolute;
            top: -10px;
            right: -5px;
            width: 16px;
            height: 16px;
            background: var(--mb-report-icon) center / contain no-repeat;
          }
        }
      }

      .line {
        display: block;
        width: 1px;
        height: 24px;
        margin: 0 20px;
        background: #f4f4f4;
      }
    }

    .myincome-list {
      width: 100%;
      margin-top: 20px;

      .list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 40px;
        font-family: var(--number-font);
        font-size: var(--fs-14);
        font-weight: var(--fw-500);
        color: #333;

        > span {
          display: block;
          white-space: nowrap;
          font-family: var(--string-font);
          font-size: var(--fs-14);
          font-weight: var(--fw-500);
        }

        .myincome-beans {
          display: flex;
          align-items: center;

          i {
            display: block;
            margin: 0 4px;
            color: #666666;
          }

          > img {
            width: 14px;
            height: 14px;
          }
        }

        &.todayIncome {
          font-family: var(--number-font);
          font-size: var(--fs-14);
          font-weight: var(--fw-600);
          color: var(--mb-today-income-color);

          > span {
            font-family: var(--number-font);
          }

          .myincome-beans i {
            color: var(--mb-today-income-color);
          }
        }

        &.lineBottom {
          margin-bottom: 10px;
          border-bottom: 1px solid #f4f4f4;
        }
      }
    }
  }

  .withdrawal-box {
    position: fixed;
    bottom: 0;
    left: 50%;
    width: 100%;
    padding: 20px 0 30px;
    background-color: rgba($color: #f4f4f4, $alpha: 0.4);
    transform: translate(-50%);

    .withdrawal {
      width: 289px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      font-family: var(--string-font);
      font-size: var(--fs-16);
      font-weight: var(--fw-500);
      color: var(--mb-withdrawal-color);
      text-align: center;
      background: var(--mb-withdrawal-bg);
      border-radius: 22px;
    }
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .container-help {
    .main {
      .income {
        .income-box.total-income {
          .report-icon {
            right: unset;
            left: -5px;
          }
        }
      }
    }
  }
}
</style>
